const APP_CLIENT_ARG: string = import.meta.env.VITE_APP_CLIENT_ARG;
const APP_CLIENT_CHI: string = import.meta.env.VITE_APP_CLIENT_CHI;
const APP_CLIENT_MEX: string = import.meta.env.VITE_APP_CLIENT_MEX;
const APP_CLIENT_ESP: string = import.meta.env.VITE_APP_CLIENT_ESP;
const APP_CLIENT_AGENTE_MEX: string = import.meta.env.VITE_APP_CLIENT_AGENTE_MEX;
const APP_CLIENT_CONTEMPORA: string = import.meta.env.VITE_APP_CLIENT_CONTEMPORA;
const APP_CLIENT: string = import.meta.env.VITE_APP_CLIENT;
const currentDomain = window.location.origin;

interface DomainToSubDomainInitialMap {
  [key: string]: string;
}

const domainToSubDomainInitialMap: DomainToSubDomainInitialMap = {
  [APP_CLIENT]: 'MEXICO',
  [APP_CLIENT_MEX]: 'MEXICO',
  [APP_CLIENT_AGENTE_MEX]: 'MEXICO',
  [APP_CLIENT_CHI]: 'CHILE',
  [APP_CLIENT_ARG]: 'ARGENTINA',
  [APP_CLIENT_ESP]: 'SPAIN',
  [APP_CLIENT_CONTEMPORA]: 'CONTEMPORA',
};

const getSubDomainInitial = (): string => {
  return domainToSubDomainInitialMap[currentDomain] ?? 'MEXICO';
};

export default getSubDomainInitial;
